import { Sparkles } from 'lucide-react';
import { GIFT_BONUS_AMOUNT, GIFT_VALIDITY_LABEL } from '@/data/giftcards2027';

export const GiftCardVoucher = ({ amount, bonus = 0, dedication, recipient, sample = false }) => (
  <div
    className="relative bg-night rounded-2xl border border-champagne/40 shadow-2xl p-6 md:p-8 overflow-hidden"
    data-testid="giftcard-voucher-preview"
  >
    <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-champagne/10 blur-2xl" />
    {sample && (
      <span className="absolute top-4 right-4 text-[10px] font-body uppercase tracking-widest bg-ivory/10 text-ivory/70 border border-ivory/20 px-2.5 py-1 rounded-full">
        Anteprima
      </span>
    )}
    <img src="/images/logo-new-white.png" alt="La Villa" className="h-8 w-auto mb-6 opacity-90" />
    <p className="font-body text-[10px] uppercase tracking-[0.35em] text-champagne mb-1">La Villa Gift Card</p>
    <div className="flex items-end gap-3 mb-1">
      <p className="font-heading text-5xl text-ivory">{amount} €</p>
      {bonus > 0 && (
        <p className="font-body text-xs text-champagne mb-2" data-testid="voucher-bonus-line">
          + {bonus} € bonus aperitivo
        </p>
      )}
    </div>
    <p className="font-body text-xs text-stone-400 mb-5">Credito da utilizzare alla Villa · Stagione 2027</p>
    <div className="border-t border-ivory/10 pt-4 min-h-[64px]">
      {recipient && <p className="font-body text-xs text-stone-400 mb-1">Per {recipient}</p>}
      <p className="font-heading italic text-ivory/90 leading-snug">
        {dedication || 'Un\u2019estate tutta per te. Buon compleanno!'}
      </p>
      {!dedication && sample && (
        <p className="font-body text-[10px] text-stone-500 mt-1">Esempio di dedica — potrai scrivere la tua</p>
      )}
    </div>
    <div className="flex items-center justify-between mt-5 pt-4 border-t border-ivory/10">
      <p className="font-body text-[10px] text-stone-500">Valida fino al {GIFT_VALIDITY_LABEL}</p>
      <div className="flex items-center gap-1.5">
        <Sparkles size={12} className="text-champagne" />
        <p className="font-body text-[10px] uppercase tracking-widest text-stone-500">Castelfranco Emilia</p>
      </div>
    </div>
  </div>
);
